import { Form as BoostrapForm, FormCheckProps, FormControlProps } from 'react-bootstrap';
import { FormProvider, UseFormReturn, useForm, UseFormProps } from 'react-hook-form';
import { ControlledSelect } from './Select';
import { formInputWithValidation } from '../hoc/formInputWithValidation';
import { FeedbackWithContext } from './FeedbackWithContext';
import { PeriodSelect } from './PeriodSelect';
import { CurrencyInput, CurrencyInputProps } from './CurrencyInput';
import {
  AmountInput,
  AmountInputProps,
  Datepicker,
  PasswordInput,
  PasswordInputProps,
  TextInput,
  TextInputProps,
  Select as OrbitaSelect,
  SelectProps,
} from '@orbita-ui/core';
import { orbitaInputWithValidation } from '../hoc/orbitaInputWithValidation';
import styled from 'styled-components';
import { DatepickerProps } from '../models/OrbitaHelpers';

const Form = styled(BoostrapForm)`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const FormWithValidation = ({
  reactFormHookMethods,
  onSubmit,
  children,
  formProps,
  ...rest
}: {
  onSubmit: (...params: any) => any;
  children: any;
  formProps?: UseFormProps<any, any>;
  reactFormHookMethods?: UseFormReturn<any, any>;
  className?: string;
}) => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const reactFormMethods = reactFormHookMethods || useForm(formProps);
  const {
    handleSubmit,
    formState: { isSubmitted },
  } = reactFormMethods;
  return (
    <FormProvider {...reactFormMethods}>
      <Form
        noValidate
        onSubmit={handleSubmit(onSubmit)}
        validated={isSubmitted}
        {...rest}
      >
        {children}
      </Form>
    </FormProvider>
  );
};

export default Object.assign(FormWithValidation, {
  // Orbita
  TextInput: orbitaInputWithValidation<TextInputProps>(TextInput),
  PasswordInput: orbitaInputWithValidation<PasswordInputProps>(PasswordInput),
  AmountInput: orbitaInputWithValidation<Partial<AmountInputProps>>(AmountInput),
  CurrencyInput: orbitaInputWithValidation<CurrencyInputProps>(CurrencyInput),
  Datepicker: orbitaInputWithValidation<DatepickerProps>(Datepicker, {
    reloadOnReset: true,
  }),
  Select: orbitaInputWithValidation<Partial<SelectProps>>(
    ({ onChange, options, ...props }: any) => (
      <OrbitaSelect
        onChange={onChange}
        options={options}
        defaultValue={props.value}
        {...props}
      />
    ),
  ),

  // Bootstrap
  Control: Object.assign(formInputWithValidation<FormControlProps>(Form.Control), {
    Feedback: FeedbackWithContext,
  }),
  Check: formInputWithValidation<FormCheckProps>(Form.Check),
  LegacySelect: Object.assign(ControlledSelect, {
    Period: PeriodSelect,
  }),
});
